var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.login)?_c('Upload'):_vm._e(),(!_vm.login)?_c('Login',{on:{"entrar":function($event){_vm.login = true}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }